import { createSlice } from '@reduxjs/toolkit';
import {
    getReceiptPaymentReport,
    getReceipts,
    getReceiptsWithPresign,
    getServiceCategories,
} from './thunk';

export const initialState = {
  services: [],
  servicesTotal: 0,
  receipts: [],
  receiptsTotal: 0,
  paymentReport: {},
};

const ServiceSlice = createSlice({
  name: 'Services',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getServiceCategories.fulfilled, (state: any, action: any) => {
      state.services = action.payload?.data || [];
      state.servicesTotal = Number(action.payload?.total || 0);
    });
    builder.addCase(getReceipts.fulfilled, (state: any, action: any) => {
      state.receipts = action.payload?.data || [];
      state.receiptsTotal = Number(action.payload?.total || 0);
    });
    builder.addCase(getReceiptsWithPresign.fulfilled, (state: any, action: any) => {
      state.receipts = action.payload?.data || [];
      state.receiptsTotal = Number(action.payload?.total || 0);
    });
    builder.addCase(getReceiptPaymentReport.fulfilled, (state: any, action: any) => {
      state.paymentReport = action.payload;
    });
  },
});

export default ServiceSlice.reducer;
